import React from 'react'
import PropTypes from 'prop-types'
import {
  NextUpEndBackground,
  NextUpEndContent,
  NextUpEndMain,
} from './index.style'
import Container from '../Container'
import Spacer from '../Spacer'
import Button from '../Button'
import PageTransitionLink from '../PageTransitionLink'
import { Heading3 } from '../TextStyles'
import { colors } from '../../styles/vars/colors.style'
import ScrollSection from '../ScrollSection'
import AnimateSlideIn from '../animation/AnimateSlideIn'
import AnimateScaleIn from '../animation/AnimateScaleIn'
import AnimateSplitText from '../animation/AnimateSplitText'
import backgroundImage from '../Expeditions/images/expeditions@2x-compress.jpg'

const NextUpEnd = ({ id, number, title, to }) => {
  return (
    <ScrollSection>
      <NextUpEndMain>
        <NextUpEndBackground>
          <AnimateScaleIn id={`${id}-nextUpEnd-image`}>
            <img src={backgroundImage} alt="" />
          </AnimateScaleIn>
        </NextUpEndBackground>

        <Container>
          <NextUpEndContent>
            <Spacer size={[119, 238]} />

            <Heading3>
              <AnimateSplitText id={`${id}-nextUpEnd-title`}>
                <em>
                  {`Segments ${number}`}
                  <br />
                </em>{' '}
                <span dangerouslySetInnerHTML={{ __html: title }}></span>
              </AnimateSplitText>
            </Heading3>

            <Spacer size={[37, 74]} />

            <AnimateSlideIn id={`${id}-nextUpEnd-button`}>
              <PageTransitionLink to={to} mask={false}>
                <Button inline variant="outline" color={colors.light}>
                  Explore
                </Button>
              </PageTransitionLink>
            </AnimateSlideIn>

            <Spacer size={[119, 238]} />
          </NextUpEndContent>
        </Container>
      </NextUpEndMain>
    </ScrollSection>
  )
}

NextUpEnd.propTypes = {
  id: PropTypes.string,
  background: PropTypes.object,
  number: PropTypes.string,
  labelColor: PropTypes.string,
  title: PropTypes.string,
  to: PropTypes.string,
}

export default NextUpEnd
